"use client";

import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Persona } from "@/lib/constants";

interface PersonaCardProps {
  persona: Persona;
  isSelected: boolean;
  onClick: () => void;
}

export function PersonaCard({
  persona,
  isSelected,
  onClick,
}: PersonaCardProps) {
  const getBadgeColorByStage = (stage: string) => {
    switch (stage.toLowerCase()) {
      case "newly acquired":
        return "bg-green-100 text-green-800 hover:bg-green-200";
      case "potential":
        return "bg-amber-100 text-amber-800 hover:bg-amber-200";
      case "about to purchase":
        return "bg-red-100 text-red-800 hover:bg-red-200";
      case "existing":
        return "bg-blue-100 text-blue-800 hover:bg-blue-200";
      case "churned":
        return "bg-red-100 text-red-800 hover:bg-red-200";
      case "long time loyal":
        return "bg-gray-100 text-gray-800 hover:bg-gray-200";
      default:
        return "bg-gray-100 text-gray-800 hover:bg-gray-200";
    }
  };

  return (
    <Card
      className={` py-2 cursor-pointer transition-all ${isSelected ? "ring-2 ring-purple-500" : "hover:shadow-md"}`}
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-700 font-medium">
            {/* {persona.initials} */}
            <img
              src={persona?.image}
              alt={persona.initials}
              className="rounded-full"
            />
          </div>
          <div className="flex-1">
            <h3 className="font-medium text-lg">{persona.name}</h3>
            <div className="flex flex-wrap gap-2 mt-2">
              <Badge className={getBadgeColorByStage(persona.stage)}>
                {persona.stage}
              </Badge>
              <Badge className="bg-blue-100 text-blue-800 hover:bg-blue-200">
                Online
              </Badge>
              <Badge className="bg-purple-100 text-purple-800 hover:bg-purple-200">
                Starbucks
              </Badge>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
